import { createContext, useContext, useEffect, useMemo, useState } from 'react';

export const languageOptions = [
    { code: 'fr', label: 'FR', name: 'Français' },
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'es', label: 'ES', name: 'Español' },
];

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        if (typeof window === 'undefined') return 'fr';
        return window.localStorage.getItem('neuroptimisme-language') || 'fr';
    });

    useEffect(() => {
        window.localStorage.setItem('neuroptimisme-language', language);
        document.documentElement.lang = language;
    }, [language]);

    const value = useMemo(() => ({ language, setLanguage }), [language]);

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) throw new Error('useLanguage must be used inside LanguageProvider');
    return context;
};
